"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _switch = _interopRequireDefault(require("britive-design-system/core/components/switch"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _lodash = require("lodash");

var _utils = require("../utils");

var _infoIcon = _interopRequireDefault(require("../../../assets/infoIcon.svg"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.advanced-settings-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .advanced-settings-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n\n.margin-top-32 {\n  margin-top: 2rem; }\n\n.margin-top-8 {\n  margin-top: 0.5rem; }\n\n.reset-button {\n  cursor: pointer;\n  color: #067fdb;\n  font-size: 1rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n";
  var fileName = "compone_Settings";
  var element = document.querySelector("style[data-sass-component='compone_Settings']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Justification = function Justification(_ref) {
  var handleJustificationChange = _ref.handleJustificationChange,
      handleResetJustification = _ref.handleResetJustification,
      settingsResp = _ref.settingsResp,
      _ref$displayReset = _ref.displayReset,
      displayReset = _ref$displayReset === void 0 ? false : _ref$displayReset,
      showToast = _ref.showToast;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpressionOpen = _useState2[0],
      setIsExpressionOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      regexInput = _useState4[0],
      setRegexInput = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      stringInput = _useState6[0],
      setStringInput = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      isValid = _useState8[0],
      setIsValid = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = _slicedToArray(_useState9, 2),
      showReset = _useState10[0],
      setShowReset = _useState10[1];

  var infoMessage = "Supports POSIX Basic Regular Expressions:\n^ for start,\n$ for end,\n. for any character,\n[abc] for character classes,\n* for repetition,\n\\(...\\) for grouping.\nEscape special characters like \\+, \\?, and \\| as needed.";
  (0, _react.useEffect)(function () {
    if (settingsResp !== null && settingsResp !== void 0 && settingsResp.isInherited) {
      setShowReset(false); // Hide reset button if isInherited is true
    }
  }, [settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isInherited]);
  (0, _react.useEffect)(function () {
    setRegexInput(settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.justificationRegex);
  }, [settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.justificationRegex]);

  var saveRegEx = function saveRegEx() {
    var result = (0, _utils.validateRegex)(regexInput, stringInput);

    if (result) {
      setShowReset(true);
      handleJustificationChange({
        justificationRegex: regexInput,
        settingsType: "JUSTIFICATION",
        isInherited: false
      });
      closeModal();
      showToast('Regular Expression saved successfully.', 'success');
    } else {
      setIsValid(result);
    }
  };

  var closeModal = function closeModal() {
    setIsExpressionOpen(false);
    setStringInput('');
    setRegexInput('');
    setIsValid(null);
  };

  var validateString = function validateString() {
    var result = (0, _utils.validateRegex)(regexInput, stringInput); // Call the reusable function

    setIsValid(result);
  };

  var justificationModalButtons = [{
    text: 'Save',
    onClick: saveRegEx,
    size: 'medium'
  }, {
    text: 'Cancel',
    variant: 'secondary',
    onClick: closeModal,
    size: 'medium'
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading5"
  }, " ", 'Advanced Settings', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", (0, _utils.getInfoText)(), " ")), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading5"
  }, 'Justification Settings ', (settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isInherited) && '(Inherited)  ', displayReset && showReset && /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.resetButton,
    onClick: function onClick() {
      setShowReset(false);
      handleResetJustification();
    }
  }, (0, _utils.isPolicyPath)() ? "Reset to Profile" : (0, _utils.isProfilePath)() ? 'Reset to Application' : 'Reset to Default'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Justification Required at Checkout', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_switch.default, {
    label: settingsResp !== null && settingsResp !== void 0 && settingsResp.isJustificationRequired ? 'Enabled' : 'Disabled',
    checked: (settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isJustificationRequired) || false,
    onToggle: function onToggle(checked) {
      setShowReset(true);
      handleJustificationChange({
        isJustificationRequired: !checked,
        settingsType: "JUSTIFICATION",
        isInherited: false
      });
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Regular Expression for Justification', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: 'secondary',
    onClick: function onClick() {
      setIsExpressionOpen(true);
      setRegexInput(settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.justificationRegex);
    }
  }, settingsResp !== null && settingsResp !== void 0 && settingsResp.justificationRegex ? 'View Expression' : 'Add Expression'))), isExpressionOpen && /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 500,
    title: "Add Regular Expression",
    onCancel: closeModal,
    buttons: justificationModalButtons
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Enter Regular Expression", /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: infoMessage,
      position: "bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.infoIcon
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _infoIcon.default
    })))),
    error: !(0, _lodash.isEmpty)(regexInput) && !(0, _utils.isValidRegex)(regexInput),
    errorMsg: "The regular expression is invalid.",
    value: regexInput,
    onChange: function onChange(e) {
      setRegexInput(e.target.value);
      setStringInput('');
      setIsValid(null);
    }
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    label: 'Enter Test String',
    value: stringInput,
    onChange: function onChange(e) {
      return setStringInput(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: 'secondary',
    onClick: validateString,
    disabled: (0, _lodash.isEmpty)(regexInput) || (0, _lodash.isEmpty)(stringInput)
  }, 'Validate Expression'), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, isValid !== null && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      padding: '10px',
      border: '1px solid'
    }
  }, "Result: ", isValid ? "Successful." : "Test String entered not matching regular expression.")))));
};

Justification.propTypes = {
  settingsResp: _propTypes.default.object,
  handleJustificationChange: _propTypes.default.func.isRequired,
  handleResetJustification: _propTypes.default.func.isRequired,
  displayReset: _propTypes.default.bool,
  showToast: _propTypes.default.func
};
var _default = Justification;
exports.default = _default;